import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'myNoteFilterWithSearchText'
})
export class MyNoteFilterWithSearchTextPipe implements PipeTransform {

  transform(items: any[], filter: any, type: any, text: String): any {
    if (!items) return [];
    if (!text) {
      return items.filter((item) => item.mID === filter.mID);
    } else {
      return items.filter((item) => {
        if (item.mID === filter.mID) {
          if (type.type === "S") {
            return item.noteScenarios.toLocaleLowerCase().includes(text);
          } else if (type.type === "I") {
            return item.noteIssues.toLocaleLowerCase().includes(text);
          } else {
            return item.noteNotes.toLocaleLowerCase().includes(text);
          }
        }
      });
    }
  }

}
